import { render, staticRenderFns } from "./BankTransactionsPaxesTable.vue?vue&type=template&id=577969cd&"
import script from "./BankTransactionsPaxesTable.vue?vue&type=script&lang=js&"
export * from "./BankTransactionsPaxesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports